import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { forTemplate } from 'app/common/lib/util/i18n';
import styles from './InviteTeamMembersForm.less';
import { InviteTeamMembersAutocompleteComponent } from '../invite-team-members-autocomplete-component';
import { InviteTeamMembersProps } from './InviteTeamMembers';
import { useFeatureFlag } from '@trello/feature-flag-client';
const ModelLoader = require('app/scripts/db/model-loader');

const format = forTemplate('org_members');

interface InviteTeamMembersFormProps extends InviteTeamMembersProps {
  startAnimation: () => void;
  fullWidthButton?: boolean;
  className?: string;
  onInviteTeamMembersSuccess?: () => void;
  preventTextareaResize?: boolean;
}

export const InviteTeamMembersForm: React.FunctionComponent<InviteTeamMembersFormProps> = ({
  orgId,
  orgDisplayName,
  model,
  startAnimation,
  fullWidthButton,
  className,
  onInviteTeamMembersSuccess,
  preventTextareaResize,
}) => {
  const defaultMessage = format('personalized-message-2', {
    teamName: orgDisplayName,
  });
  const [invitationMessage, setInvitationMessage] = useState(defaultMessage);
  const [orgModel, setOrgModel] = useState();
  const messageEnabledFlag = useFeatureFlag(
    'enable-invite-email-message',
    false,
  );

  useEffect(() => {
    const getModel = async () => {
      if (!model) {
        const organization = await ModelLoader.loadOrganizationData(orgId);
        await setOrgModel(organization);
      }
    };
    getModel();
  }, [model, orgId]);

  const changedInviteMessage = defaultMessage !== invitationMessage;

  const updateInvitationMessage = (
    event: React.ChangeEvent<HTMLTextAreaElement>,
  ) => {
    setInvitationMessage(event.target.value);
  };

  return (
    <div className={classNames(styles.formWrapper, className)}>
      <div className={styles.heading}>{format('invite-your-team')}</div>
      <div className={styles.subtitle}>
        {format('trello-makes-teamwork-your-best-work')}
      </div>
      <InviteTeamMembersAutocompleteComponent
        placeholder={format('invite-input-placeholder')}
        orgId={orgId}
        model={model || orgModel}
        optionsAddMembers={{ invitationMessage, changedInviteMessage }}
        onEmailSelected={startAnimation}
        fullWidthButton={fullWidthButton}
        onInviteTeamMembersSuccess={onInviteTeamMembersSuccess}
      >
        <div className={styles.autocompleteHelpText}>
          <strong>{format('pro-tip')}</strong>{' '}
          {format('paste-as-many-emails-here-as-needed')}
        </div>
        {messageEnabledFlag && (
          <label className={styles.invitationMessageLabel}>
            <span className={styles.invitationMessageLabelText}>
              {format('give-this-message-a-personal-touch')}
            </span>
            <textarea
              className={classNames(styles.invitationMessage, {
                [styles.invitationMessageNoResize]: preventTextareaResize,
              })}
              placeholder={format('personalized-message-placeholder')}
              value={invitationMessage}
              onChange={updateInvitationMessage}
              maxLength={500}
            />
          </label>
        )}
      </InviteTeamMembersAutocompleteComponent>
    </div>
  );
};
